// extracted by mini-css-extract-plugin
var _1 = "i2RogXzNTq";
var _2 = "U5FFRcTPG5";
export { _1 as "disabled", _2 as "root" }
